import React from 'react';
import { nonImplemented } from '../../../components/message-boxes/ErrorMessage';
import { FancyButton } from '../../../components/primitives/FancyButton';
import { TpAssetInfo } from '../../../data/assets/interfaces';
import styles from '../AssetView.module.scss';

interface TpActionProps {
  assetInfo: TpAssetInfo;
  children?: React.ReactNode;
  dashboardtemplate?: any;
}

const Actions = (props: TpActionProps) => {
  const keyToActionMapper: any = (key: string) => {
    switch (key) {
      default:
        return nonImplemented;
    }
  };

  const actionButtons = props.dashboardtemplate.map((action: any) => {
    return (
      <FancyButton iconName={action.type} onClick={keyToActionMapper(action.type)}>
        {action.title}
      </FancyButton>
    );
  });

  if (actionButtons.length == 0) return null;

  return (
    <div className={styles.actionButtonSection}>
      <div style={{ padding: '20px 0 20px 40px' }}>
        {actionButtons.map((button: any, idx: any) => (
          <React.Fragment key={idx}>
            {button}
            <div style={{ height: '20px' }} />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Actions;
